import { useMemo } from 'react';

import { mdiMinus } from '@lumapps/lumx/icons';
import { useTranslate } from '@lumapps/translations';
import { ReactEditor, useSlateStatic } from '@lumapps/wrex/slate';
import { TOOLBAR_ITEM_TYPE, ToolbarItem } from '@lumapps/wrex/types';

import { DIVIDER } from '../../../constants';
import { WREX_TYPOGRAPHY } from '../../../keys';
import { TypographyEditor } from '../../../types';

/**
 * Hook to add a divider at the cursor position in the editor.
 */
export const useDividerButton = (otherProps?: any) => {
    const editorStatic = useSlateStatic() as ReactEditor & TypographyEditor;
    const { translateKey } = useTranslate();

    return useMemo((): ToolbarItem => {
        const onClick = () => {
            editorStatic.insertDivider();
        };

        return {
            type: TOOLBAR_ITEM_TYPE.OPTION,
            itemKey: DIVIDER,
            icon: mdiMinus,
            onClick,
            label: translateKey(WREX_TYPOGRAPHY.DIVIDER),
            otherProps,
        };
    }, [editorStatic, otherProps, translateKey]);
};
